function add_attr(){
  var form = $('#cart_form');
  form.find('.all_ring_size').remove();
  var ring_size = [];
  $.getJSON("/cart.js", function(cart) {
    other_pro_qty = 0, free_sizers_in_cart = 0, silicon_ring_qty = 0;
    $(cart.items).each(function(i,item){
      if(item.handle == 'silicone-ring'){
        silicon_ring_qty = silicon_ring_qty + item.quantity;
      }
      if(item.handle == 'sizers'){
        free_sizers_in_cart = free_sizers_in_cart + item.quantity;
      }
      var set_sku = (item.properties != null && item.properties['_shopsku']) ? item.properties['_shopsku'] : item.sku;
      if(set_sku != '' || set_sku != null){
        var item_l = set_sku + '-5555';
        ring_size.push(item_l);
      }
    });
    other_pro_qty = cart.item_count - free_sizers_in_cart;
    other_pro_qty = other_pro_qty - silicon_ring_qty;
    if(silicon_ring_qty >= 2){
      $('.cart__quantity[is_silicon_ring] .quantity-input-control, .cart__quantity[is_silicon_ring] .plus-control').css('pointer-events','none');
    }else{
      $('.cart__quantity[is_silicon_ring] .quantity-input-control, .cart__quantity[is_silicon_ring] .plus-control').css('pointer-events','auto');
    }
    if(ring_size.length > 1){
      ring_size = ring_size.join(' , ');
    }
    if(ring_size.length == 0){
      ring_size = '';
    }
    form.append('<input type="hidden" class="all_ring_size" name="attributes[ShopSku-Size]" value="'+ ring_size +'">');
    jQuery.post('/cart/update.js', "attributes[ShopSku-Size]=" + ring_size);
  });
}


/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsCart = {
  init: function ($section) {
 	add_attr();
    // Add settings from schema to current object
    //Shopify.theme.jsCart = $.extend(this, Shopify.theme.getSectionData($section));

    this.$section = $section;

    $(document).on('click', '[data-cart-page-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).data('line-item-key');
      Shopify.theme.jsCart.removeFromCart(lineID);

      return false;
    });

    // Prevent the ajax cart form from being submitted when pressing the "Enter" key
    $('#cart_form').keydown(function(e){
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });
  },
  removeFromCart: function (lineID) {
    const $cartItem = Shopify.theme.jsCart.$section.find(`[data-line-item="${lineID}"]`);
    $cartItem.css('opacity', '0.5');
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {
        $cartItem.addClass('animated zoomOut')
        $cartItem.remove();
        other_pro_qty = 0, free_sizers_in_cart = 0, silicon_ring_qty = 0;
        if($('.sizer_id').length && $('.cart__card.sizer_line').length){
          $(cart.items).each(function(i,item){
            if(item.handle == 'silicone-ring'){
              silicon_ring_qty = silicon_ring_qty + item.quantity;
            }
            if(item.handle == 'sizers'){
              free_sizers_in_cart = free_sizers_in_cart + item.quantity;
            }
            other_pro_qty = cart.item_count - free_sizers_in_cart;
            other_pro_qty = other_pro_qty - silicon_ring_qty;
          });
          if(other_pro_qty == 0){
            Shopify.Cart.FreeSizer.remove();
          }else if(free_sizers_in_cart > other_pro_qty || free_sizers_in_cart < other_pro_qty){
            Shopify.Cart.FreeSizer.set(other_pro_qty);
          }else{
            refresh_custom_cart();
          }
        }else{
          Shopify.theme.jsCart.updateView(cart, lineID);
          if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
            Shopify.theme.jsAjaxCart.updateView();
          }
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  updateView: function (cart, lineID) {
    if($('.sizer_id').length){
      var found_sizer = 0;
      var sizer_id = Number($('.sizer_id').val());
      $(cart.items).each(function(i,v){
        if(v.id == sizer_id){
          found_sizer = 1;
        }
      });
      if(found_sizer == 1 && cart.item_count <= 1){
        Shopify.Cart.FreeSizer.remove();
      }
    }
    if (cart.item_count > 0) {
      $.ajax({
        dataType: "json",
        async: false,
        cache: false,
        dataType: 'html',
        url: "/cart",
        success: function (html) {

          if (lineID !== null) {

            const updatedItems = $(html).find('.cart__item-list .cart__card');
            const currentItems = $('.cart__item-list .cart__card');

            // Checks if BOGO applied and there is a change in the number of line items
//             if (updatedItems.length != currentItems.length){
              const updatedCartList = $(html).find('.cart__item-list');
              // Re-append cart items
              $('.cart__item-list').replaceWith(updatedCartList);
//             }

            $(currentItems).each(function(index, element){
              $(element).attr('data-line-item', (index + 1));
              $(element).find('[data-line-item-key]').attr('data-line-item-key', (index + 1));
            })

            const itemTotal = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__total');
            const quantityInput = $(html).find(`[data-line-item="${lineID}"]`).find('.quantity-input');
            const itemPrice = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__price');

            $(`[data-line-item="${lineID}"]`).find('.cart__total').replaceWith(itemTotal);
            $(`[data-line-item="${lineID}"]`).find('.quantity-input').replaceWith(quantityInput);
            $(`[data-line-item="${lineID}"]`).find('.cart__price').replaceWith(itemPrice);

          }

          const subtotal = $(html).find('.cart__subtotal-container');
          const discounts = $(html).find('.cart__discounts');
          const savings = $(html).find('.cart__total-savings');

          $('.cart__subtotal-container').replaceWith(subtotal);

          if (discounts.length > 0 && $('.cart__discounts').length < 1) {
            $('.cart__subtotal-container').before(discounts);
          } else {
            $('.cart__discounts').replaceWith(discounts);
          }

          if (savings.length > 0 && $('.cart__total-savings').length < 1) {
            $('.cart__subtotal-container').after(savings);
          } else {
            $('.cart__total-savings').replaceWith(savings);
          }

          $('[data-bind="itemCount"]').text(cart.item_count);

        }
      });

    } else {
      $('.cart__empty-cart-message').removeClass('is-hidden');
      $('.cart__form').addClass('is-hidden');
      $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
      $('[data-bind="itemCount"]').text('0');
    }
    add_attr();
  },
  unload: function ($section) {
    // Clear event listeners in theme editor
    $('[data-cart-page-delete]').off();
    $('#cart_form').off();
  }
}

/******/ })()
;